const _ = require('lodash')
const moment = require('moment')

/**
 * Hardcoded constant strings, variables, etc
 */
const vals = {
  GRAPHS: {
    TOOLTIP_ROI_INFO: {
      sector: 'This chart shows the value and cost difference between each sector in your portfolio. Anything below 1% is denoted as other.',
      stage: 'This chart shows a comparison of the value and cost in the same category.',
      direct: 'This chart shows the percent and dollar value of your investments as a direct investor or as an LP in a fund.',
      geography: 'This chart shows the value and cost of your total investments in a specific geographic area.',
      status: 'This chart shows the percent and value associated to the company status.'
    },
    TOOLTIP_VALUE_INFO: {
      sector: 'This chart shows the total value of your investments and the percent of investment dollars by sector.',
      stage: 'This chart shows the percent and amount of dollars of your portfolio in that stage.',
      direct: 'This chart shows your investments directly into a company or into a company as an LP in a fund.',
      geography: 'This chart shows the percent of total dollars invested and amount of money invested in a specific geographic area.',
      status: 'This chart shows a comparison of the total value of different groups in the same category.'
    },
    TOOLTIP_TIME_INFO: {
      default: 'This graph shows the ROI of your portfolio over time in cost and value. Cost also shows the last time you invested.'
    },
    TOOLTIP_COMPANY_INFO: {
      default: 'This chart compaires the companies in their matching sector to each other.'
    }
  },
  TRANSACTION_TYPE: ['Management Fee', 'Fund Expenses'], //'Miscellaneous'
  TOOLTIP_OVERVIEW: {
    default: `<b>Portfolio Value</b>: Summation of all values of all companies in your portfolio on paper.<br/>
<b>Portfolio Cost</b>: Summation of all costs of all companies in your portfolio on paper.<br/>
<b>Portfolio Gain</b>: The total value of your portfolio on paper.<br/>
<b>Total Cash Invested</b>: Summation of the costs of all companies that are either ‘exit’ or ‘acquired’ in your portfolio.<br/>
<b>Total Cash Returned</b>: Summation of the values of all companies that are either ‘exit’ or ‘acquired’ in your portfolio.<br/>
<b>Combined exit multiple</b>: The ratio of cash invested and cash returned that are either ‘exit’ or ‘acquired’ in your portfolio.`
  },
  PORTFOLIO: {
    CONTEXT: ['Invest', 'Diligence', 'Mentor'],
    CONTEXT_MAP: { Invest: 'invest', Diligence: 'watch', Mentor: 'mentor' },
    DIRECT_LP: ['Direct', 'LP', 'Diligence', 'Mentor'],
    FIELDS: ['ownership', 'initial_investment', 'last_funding_round', 'cost', 'value', 'direct', 'notes', 'company', 'profile', 'logo_url'],
    HEADERS: ['OWNERSHIP %', 'OWNERSHIP', 'COST', 'VALUE', 'INITIAL INVESTMENT', 'LAST FUNDING ROUND', 'DIRECT/LP', 'NOTES', 'LOGO URL']
  },
  GRAPH_OPTIONS: ['sector', 'stage', 'geography', 'status'],
  XLS_IMPORT: {
    HEADERS: ['COMPANY', 'STATUS', 'OWNERSHIP %', 'OWNERSHIP', 'COST', 'VALUE', 'INITIAL INVESTMENT', 'LAST FUNDING ROUND', 'CURRENT STAGE', 'SECTOR', 'GEOGRAPHY', 'DIRECT/LP', 'NOTES', 'LOGO URL']
  },
  PORTFOLIO_HEADERS: ['COMPANY', 'COMPANY URL', 'STATUS', 'OWNERSHIP %', 'OWNERSHIP', 'COST', 'VALUE', 'INITIAL INVESTMENT', 'LAST FUNDING ROUND', 'CURRENT STAGE', 'SECTOR', 'GEOGRAPHY', 'DIRECT/LP', 'NOTES', 'LOGO URL'],
  PORTFOLIO_DEFAULTS: { 'geography': 'Unspecified', 'sector': 'Unknown', 'value': 0, 'cost': 0, 'ownership': 0, 'logo_url': '' },
  NUMBER_HEADERS: ['ownership', 'cost', 'value', 'gain_loss', 'multiple'],
  DATE_HEADERS: ['initial', 'last_funding', 'initial_investment', 'last_funding_round'],
  STRING_HEADERS: ['status', 'sector', 'stage'],
  HEADER_MAP: { 'name': 'Company', 'status': 'Status', 'ownership': 'Ownership', 'cost': 'Cost', 'value': 'Value', 'initial_investment': 'Initial Investment', 'last_funding_round': 'Last Funding Round', 'stage': 'Current Stage', 'sector': 'Sector', 'geography': 'Geography', 'direct': 'Direct/LP', 'logo_url': 'Logo URL' },
  CURRENCIES: {
    US_DOLLAR: { display: 'US Dollar', ref: 'USD', format: { thousand: ',', symbol: '$', precision: 0 } },
    EURO: { display: 'Euro', ref: 'EUR', format: { thousand: '', symbol: '€', precision: 0 } }
  },
  PORTFOLIO_CONTEXT: { Invest: 'invest', Watch: 'watch', Mentor: 'mentor' },
  PERSON_CONTEXT: { FOUNDER: 'founder', INVESTOR: 'investor', EMPLOYEE: 'employee', ADVISOR: 'advisor' },
  SECTOR_DEFINES: ['3D Printing', 'Ad Tech', 'Advanced Manufacturing', 'Agriculture', 'Ag Tech', 'Artificial Intelligence & Machine Learning', 'Audio Tech', 'Augmented Reality', 'Automotive & Transportation', 'Autonomous Cars', 'B2B', 'B2B Payments', 'B2C', 'Beauty', 'Big Data', 'Business Products & Services', 'Cannabis', 'Clean Tech', 'Computer Hardware & Services', 'Construction Tech', 'Consumer', 'Consumer Products & Services', 'Cryptocurrency/Blockchain', 'Cybersecurity', 'Ecommerce', 'Ed Tech', 'Electronics', 'Energy & Utilities', 'Enterprise', 'Environmental Services & Equipment', 'ESports', 'Financial Tech', 'Food & Beverages', 'Food Tech', 'Gaming', 'Healthcare', 'Health Tech', 'HR Tech', 'Impact Investing', 'Industrial', 'Infrastructure', 'Insur Tech', 'Internet', 'Internet of Things (IoT)', 'Leisure', 'Life Sciences', 'Manufacturing', 'Mar tech', 'Media (Traditional)', 'Media & Tech', 'Medical Devices & Equipment', 'Metals', 'Mining', 'Mobile', 'Not for Profit', 'Telecommunications', 'MobileCommerce', 'Mobility', 'Mortgage Tech', 'Netowrking & Equipment', 'Oil & Gas', 'Oncology', 'Other', 'Nano Tech', 'Real Estate', 'Real Estate Tech', 'Reg Tech', 'Restaurant Tech', 'Retail/Distrabution', 'Retail Tech', 'Ridesharing', 'Risk & Security', 'Robotics', 'SaaS (Software as a Service)', 'Security', 'Semicontuctors', 'Software', 'Software (Non-internet/Mobile)', 'Space Tech', 'Sports', 'Telecommunication', 'Tools', 'Transportation', 'Travel', 'Venture Fund', 'Virtual Reality', 'Wearables & Quantified Self', 'Wellness'],
  STAGE_DEFINES: ['Pre-Seed', 'Seed', 'Seed Extension', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series H', 'Secondary Market', 'IPO', 'Private'],
  WORKSPACE_STAGES: ['Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series H', 'Generalist'],
  TERMS: ['Bridge Loan', 'Warrant', 'Stock Certificate', 'SAFE Note', 'Convertible Debt'],
  STATUS_DEFINES: ['In-Active', 'Active', 'IPO', 'Acquired', 'Out of Business', 'Unknown'],
  LEGEND: {
    BACKGROUND_COLORS_1: ['#9d64aa', '#7766ad', '#20afc7', '#50b497', '#66bd51', '#afc353', '#fbd445', '#ff9900', '#e04b4b', "#cc5199"],
    BACKGROUND_COLORS_2: ['#fbd445', '#fac83c', '#fabc33', '#f9b02b', '#f9a423', '#f8991d', '#f28a2b', '#ec7c36', '#e86d3f', '#e45d46', '#e04b4b'],
    BACKGROUND_COLORS_SUBSET_1: ['#ceaed6', '#c29bcb', '#b589bf', '#a977b4', '#9c64a8', '#8a5696', '#784883', '#673971', '#552b5e', '#431d4c', '#421c4a'], //purple
    BACKGROUND_COLORS_SUBSET_2: ['#b4abd6', '#a59acc', '#9689c1', '#8677b7', '#7766ac', '#68589a', '#584a88', '#493c75', '#392e63', '#392e63'], // blue-purple?
    BACKGROUND_COLORS_SUBSET_3: ['#9ce1e8', '#7dd4e0', '#5ec8d7', '#3ebbcf', '#1faec6', '#1b95a9', '#177b8b', '#12626e', '#0e4850', '#0a2f33'], // light-blue
    BACKGROUND_COLORS_SUBSET_4: ['#95d8c4', '#83cfb9', '#72c5ad', '#60bca2', '#4eb396', '#429980', '#36806a', '#2b6655', '#1f4d3f', '#133329'], // light-green
    BACKGROUND_COLORS_SUBSET_5: ['#ace09d', '#9bd78b', '#8ace78', '#79c566', '#68bc53', '#58a046', '#488438', '#37682b', '#274c1d', '#173010'], // green
    BACKGROUND_COLORS_SUBSET_6: ['#d4dda2', '#cbd78e', '#c1d07a', '#b8ca66', '#aec352', '#93a544', '#788736', '#5e6927', '#434b19', '#282d0b'], // yellow
    BACKGROUND_COLORS_SUBSET_7: ['#f9e4a5', '#f9e08d', '#fadc75', '#fad75d', '#fad345', '#d2b13a', '#aa8f2e', '#836e23', '#5b4c17', '#332a0c'], // orange
    BACKGROUND_COLORS_SUBSET_8: ['#f9c68f', '#f9bb73', '#f8af56', '#f8a33a', '#f7981d', '#d18019', '#ab6815', '#845111', '#5e390d', '#382109'], // darker-orange
    BACKGROUND_COLORS_SUBSET_9: ['#eda2a2', '#ea8c8c', '#e67777', '#e36161', '#df4b4b', '#bf3f3f', '#9e3333', '#7e2626', '#5d1a1a', '#3d0e0e'], // red
    BACKGROUND_COLORS_SUBSET_10: ['#eab2d5', '#e39ac6', '#db82b7', '#d469a8', '#cc5199', '#ae4382', '#90356b', '#712853', '#531a3c', '#350c25'], // pink   
    BAR_COLORS: ['#66bd51', '#517f45', '#9D45B0', '#7766AD']
  },
  MAX_NETWORK_ERRORS: 3,
  WORKSPACES: ['Direct Investment', 'Limited Partner'],

  // reference https://support.crunchbase.com/hc/en-us/articles/115010458467-Glossary-of-Funding-Types
  FUNDING_ROUND_TYPES: ['Angel', 'Pre-Seed', 'Seed', 'Venture - Series Unknown', 'Series A', 'Series B', 'Series C', 'Equity Crowdfunding', 'Product Crowdfunding', 'Private Equity', 'Convertible Note', 'Debt Financing', 'Secondary Market', 'Grant', 'Corporate Round', 'Initial coin offering (ICO)', 'Post-IPO Equity', 'Post-IPO Debt', 'Post-IPO Secondary', 'Non-Equity Assistance'],
  INVESTMENT_TYPE: ['SAFE Note', 'Convertible Note', 'Warrant', 'Bridge Loan', 'Equity', 'Proceeds', 'Unknown'],
  INVESTMENT_PROCEEDS_TYPE: [
    // 'IPO', 'Acquisition', 'Out of Business', 'Escrow', 'Earn Out', 'Secondaries',
    'Note Redemption', 'Stock Sale', 'Distribution of Cash'],
  INVESTMENT_OFFERINGS: ['Pre-Seed', 'Seed', 'Seed - 1', 'Seed - 2', 'Seed - 3', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series H',
    'Series A - 1', 'Series B - 1', 'Series C - 1', 'Series D - 1', 'Series E - 1', 'Series F - 1', 'Series G - 1', 'Series H - 1',
    'Secondary Market', 'IPO', 'Private'],
  LINK_TYPES: ['URL', 'File'],
  LINK_TYPE_DEFAULT: 'URL',
  IMPORT_HEADERS: [{ label: 'Company', value: 'name', isMatched: false },
  { label: 'Company URL', value: 'company_url', isMatched: false },
  { label: 'Status', value: 'status', isMatched: false },
  { label: 'Ownership %', value: 'ownership', isMatched: false },
  { label: 'Cost', value: 'cost', isMatched: false },
  { label: 'Value', value: 'value', isMatched: false },
  { label: 'Initial Investment', value: 'initial_investment', isMatched: false },
  { label: 'Last Funding Round', value: 'last_funding_round', isMatched: false },
  { label: 'Current Stage', value: 'stage', isMatched: false },
  { label: 'Sector', value: 'sector', isMatched: false },
  { label: 'Geography', value: 'geography', isMatched: false },
  { label: 'Direct/LP', value: 'direct', isMatched: false },
  { label: 'Logo URL', value: 'logo_url', isMatched: false },
  { label: 'Referrer Name', value: 'referred_by_name', isMatched: false },
  { label: 'Referrer Email', value: 'referred_by_email', isMatched: false },
  { label: 'Notes', value: 'notes', isMatched: false }],
  //   { label: 'Co-founder/CEO Name', value: 'ceo_name', isMatched: false },
  // { label: 'Co-founder/CEO Email', value: 'ceo_email', isMatched: false },
  TASK_TYPES: [
    {
      value: "todo",
      label: "Todo"
    },
    {
      value: "notification",
      label: "Notification"
    },
    {
      value: "remainder",
      label: "Remainder"
    }
  ],
  COMPONENT_OPTIONS: [
    {
      value: "dashboard",
      label: "Dashboard"
    },
    {
      value: "portfolio",
      label: "Portfolio"
    },
    {
      value: "registrar",
      label: "Registrar"
    }
  ],
  ACTION_TYPE_OPTIONS: [
    {
      value: "Email",
      label: "Email"
    },
    {
      value: "Call",
      label: "Call"
    },
    {
      value: "Sign a document",
      label: "Sign a document"
    },
    {
      value: "Other",
      label: "Other"
    }
  ],
  PRIORITY_OPTIONS: [
    {
      value: "urgent",
      label: "Urgent"
    },
    {
      value: "medium",
      label: "Medium"
    },
    {
      value: "low",
      label: "Low"
    }
  ],
  URGENCY_OPTIONS: [
    {
      value: 0,
      label: 0
    },
    {
      value: 1,
      label: 1
    },
    {
      value: 2,
      label: 2
    },
    {
      value: 3,
      label: 3
    },
    {
      value: 4,
      label: 4
    },
    {
      value: 5,
      label: 5
    },
    {
      value: 6,
      label: 6
    },
    {
      value: 7,
      label: 7
    },
    {
      value: 8,
      label: 8
    },
    {
      value: 9,
      label: 9
    }
  ],
  coordinates: {
    portfolioPerformanceByYear: {
      dataGsX: 0,
      dataGsY: 0,
    },
    portfolioPerformanceTable: {
      dataGsX: 6,
      dataGsY: 0,
    },
    funnelPiePortfolioId: {
      dataGsX: 6,
      dataGsY: 3,
    },
    portfolioValueId: {
      dataGsX: 6,
      dataGsY: 12,
    },
    bubbleGainLossId: {
      dataGsX: 0,
      dataGsY: 3,
    },
    pieDiligenceId: {
      dataGsX: 0,
      dataGsY: 9,
    },
    referrerChartId: {
      dataGsX: 8,
      dataGsY: 9,
    },
    proRataChartId: {
      dataGsX: 4,
      dataGsY: 9,
    },
    // roiBarChartId: {
    //   dataGsX: 0,
    //   dataGsY: 12,
    // },
    // roiLineChartId: {
    //   dataGsX: 6,
    //   dataGsY: 12,
    // },
    roiChartsCard: {
      dataGsX: 0,
      dataGsY: 12,
    },
    newFeedCardId: {
      dataGsX: 0,
      dataGsY: 15,
    },
  },
  DOCUMENT_TYPE_OPTIONS: [
    {
      value: "Investor Report",
      label: "Investor Report"
    },
    {
      value: "Diligence Report",
      label: "Diligence Report"
    },
    {
      value: "Stock Certificates",
      label: "Stock Certificates"
    },
    {
      value: "Deal Memo",
      label: "Deal Memo"
    },
    {
      value: "Quarterly Report",
      label: "Quarterly Report"
    },
    {
      value: "Annual Report",
      label: "Annual Report"
    },
    {
      value: "Financial Statement",
      label: "Financial Statement"
    },
    {
      value: "Pitch Deck",
      label: "Pitch Deck"
    },
    {
      value: "Investment",
      label: "Investment"
    },
    {
      value: "Legal",
      label: "Legal"
    },
    {
      value: "Other",
      label: "Other"
    }
  ],
  LP_DOCUMENT_TYPE_OPTIONS: [
    {
      value: "LPA",
      label: "LPA"
    },
    {
      value: "Tax ID Number (IRS)",
      label: "Tax ID Number (IRS)"
    },
    {
      value: "Incorporation Certificate",
      label: "Incorporation Certificate"
    },
    {
      value: "Subscription agreement & Investor Questionnaire",
      label: "Subscription agreement & Investor Questionnaire"
    },
    {
      value: "W9",
      label: "W9"
    },
    {
      value: "W8",
      label: "W8"
    },
    {
      value: "Side Letter",
      label: "Side Letter"
    },
    {
      value: "Subscription Docs",
      label: "Subscription Docs"
    },
    {
      value: "Investor accreditation form",
      label: "Investor accreditation form"
    },
    {
      value: "Wire records",
      label: "Wire records"
    },
    {
      value: "Transfer Agreements",
      label: "Transfer Agreements"
    },
    {
      value: "Other",
      label: "Other"
    },
  ],
  BUBBLE_STAGE_DEFINES: ['Pre-Seed', 'Seed', 'Seed Extension', 'Seed - 1', 'Seed - 2', 'Seed - 3', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series H',
    'Series A - 1', 'Series B - 1', 'Series C - 1', 'Series D - 1', 'Series E - 1', 'Series F - 1', 'Series G - 1', 'Series H - 1',
    'Secondary Market', 'IPO', 'Private', '-', ''],
  FORMATION_DOCUMENT_TYPE_OPTIONS: [
    {
      value: "LPA",
      label: "LPA"
    },
    {
      value: "Tax ID Number (IRS)",
      label: "Tax ID Number (IRS)"
    },
    {
      value: "Incorporation Certificate",
      label: "Incorporation Certificate"
    },
    {
      value: "Certificate of Formation",
      label: "Certificate of Formation"
    },
    {
      value: "Operating Agreement",
      label: "Operating Agreement"
    },
    {
      value: "Good Standing Certificates",
      label: "Good Standing Certificates"
    },
    {
      value: "Summary of principal terms",
      label: "Summary of principal terms"
    },
    {
      value: "Fund terms",
      label: "Fund terms"
    },
    {
      value: "Formation Opinion",
      label: "Formation Opinion"
    },
    {
      value: "Fund taxation opinion",
      label: "Fund taxation opinion"
    },
    {
      value: "Other",
      label: "Other"
    },

  ],
  statusDropdown: ["Fundraising", "Deploying", "Managing", "Wind Down", "Closed"],
  stageDropdown: ["Early", "Later", "Growth"],
  sectorList: ["Homeless Shelter", "Freemium", "Industrial", "Innovation Management", "Lighting", "Mobile", "Tutoring",
    "Clean Energy", "Sustainability", "Neuroscience", "Religion", "Social CRM", "Information Technology", "Events",
    "Public Relations", "Enterprise Software", "Cloud Data Services", "Charity", "Video", "Physical Security", "Knowledge Management",
    "Self-Storage", "Hardware", "Wholesale", "Consulting", "IaaS", "IT Management", "Retail", "Space Travel", "Vertical Search", "Image Recognition",
    "Accounting", "Geospatial", "PaaS", "Real Estate", "Private Social Networking", "Wireless", "Lifestyle", "Data Mining", "Incubators", "Risk Management",
    "Law Enforcement", "Medical", "Financial Services", "Biometrics", "Local", "Aerospace", "Augmented Reality", "Credit Cards", "Mobile Devices", "Celebrity",
    "Racing", "Coworking", "Vending and Concessions", "RFID", "College Recruiting", "Developer Tools", "EBooks", "Multi-level Marketing", "Document Management", "SaaS",
    "Crowdfunding", "Outsourcing", "Biotechnology", "Personalization", "Theatre", "Social Media", "Reading Apps", "Loyalty Programs", "Toys", "Public Transportation",
    "Health Care", "Digital Media", "Alumni", "Internet", "E-Commerce", "Tobacco", "Therapeutics", "Business Development", "Impact Investing",
    "Blogging Platforms", "Crowdsourcing", "Credit", "Fraud Detection", "Energy", "Mobile Advertising", "Lead Generation", "Landscaping",
    "Customer Service", "Industrial Automation", "Email Marketing", "Child Care", "Payments", "Information Services", "Content Syndication", "Leisure", "Field-Programmable Gate Array (FPGA)", "Communications Infrastructure", "Social Bookmarking", "Power Grid", "Public Safety", "Internet of Things", "Data Center Automation", "Open Source", "Virtualization", "Waste Management", "Test and Measurement", "Social Media Advertising", "Manufacturing", "Text Analytics", "Energy Efficiency", "Cooking", "Training", "Construction", "Information and Communications Technology (ICT)", "Young Adults", "Privacy", "Electronics", "Telecommunications", "Gift Exchange", "Video Conferencing", "Web Design", "Language Learning", "Billing", "Architecture", "Professional Services", "Cloud Security", "Project Management", "Video Games", "Dental", "Music", "Universities", "B2B", "Music Education", "Brand Marketing", "Nanotechnology", "Musical Instruments", "Fashion", "Animal Feed", "Advice", "Journalism", "Lingerie", "Career Planning", "Solar", "Film", "E-Commerce Platforms", "Software", "Hedge Funds", "Social Impact", "Digital Signage", "Organic", "Professional Networking", "Recreation", "Automotive", "Semantic Search", "Content Delivery Network", "Location Based Services", "Insurance", "Outdoor Advertising", "Venture Capital", "Virtual Goods", "Video Streaming", "Legal", "Sporting Goods", "Gamification", "Apps", "Resorts", "3D Printing", "Finance", "Cloud Management", "Visual Search", "Web Browsers", "Darknet", "Semantic Web", "Soccer", "Concerts", "Local Advertising", "Computer Vision", "Dietary Supplements", "MMO Games", "National Security", "Assisted Living", "Music Venues", "Small and Medium Businesses", "Product Design", "Sports", "Infrastructure", "Aquaculture", "Direct Sales", "Wealth Management", "Direct Marketing", "Browser Extensions", "Analytics", "Content Creators", "Natural Resources", "Transportation", "Retail Technology", "In-Flight Entertainment", "Human Resources", "Event Management", "Underserved Children", "Clinical Trials", "Data Visualization", "Prediction Markets", "Collectibles", "Farmers Market", "Commercial Real Estate", "Consumer Electronics", "Travel", "Meeting Software", "Emerging Markets", "Gambling", "Supply Chain Management", "Parking", "Nutraceutical", "Natural Language Processing", "Non Profit", "Cloud Computing", "Homeland Security", "3D Technology", "Jewelry", "Advertising Platforms", "Lead Management", "Charter Schools", "QR Codes", "Digital Entertainment", "Photo Sharing", "Presentations", "Price Comparison", "Advertising", "Agriculture", "Politics", "Nightlife", "Email", "Banking", "Electrical Distribution", "Ticketing", "Shopping", "Machine Learning", "Organic Food", "Adventure Travel", "Tourism", "Publishing", "Transaction Processing", "Content Discovery", "Personal Branding", "Personal Finance", "Film Production", "Indoor Positioning", "Nightclubs", "Restaurants", "Financial Exchanges", "Edutainment", "Contact Management", "Security", "Rehabilitation", "Auctions", "SEO", "DIY", "Quantified Self", "Fleet Management", "Outdoors", "Genetics", "TV Production", "Cyber Security", "Home Renovation", "Stock Exchanges", "Robotics", "Energy Management", "Craft Beer", "CAD", "Ad Targeting", "Recycling", "Point of Sale", "Developer APIs", "Audiobooks", "Psychology", "Green Building", "Advanced Materials", "Performing Arts", "Business Intelligence", "Sales Automation", "Web Development", "Oil and Gas", "Identity Management", "Procurement", "Film Distribution", "Collaborative Consumption", "Sex Industry", "Collaboration", "Casual Games", "CRM", "Fitness", "NFC", "Parenting", "Humanitarian", "Market Research", "Photography", "Search Engine", "Data Integration", "Video Editing", "SMS", "Audio", "Network Security", "Broadcasting", "Flash Storage", "Brewing", "Education", "Alternative Medicine", "Human Computer Interaction", "Photo Editing", "Motion Capture", "Green Consumer Goods", "Coupons", "Textiles", "Product Search", "Veterinary", "Virtual Currency", "Hospitality", "Social News", "Video on Demand", "Independent Music", "Farming", "Retirement", "Group Buying", "Eyewear", "News", "Google Glass", "Operating Systems", "Linux", "Navigation", "Wine And Spirits", "Predictive Analytics", "Home Decor", "Virtual Desktop", "Property Management", "Smart Building", "Artificial Intelligence", "Corporate Training", "Big Data", "Video Chat", "Marketing Automation", "Elderly", "Communities", "Sponsorship", "Coffee", "Social Recruiting", "Flowers", "Cause Marketing", "Cosmetic Surgery", "Bioinformatics", "Water Purification", "Consumer Lending", "Logistics", "Intellectual Property", "mHealth", "Simulation", "App Discovery", "Handmade", "Personal Health", "Social Media Management", "Ediscovery", "Food Processing", "Interior Design", "Tea", "Business Information Systems", "Messaging", "Smart Home", "Guides", "Q&A", "Swimming", "Beauty", "iOS", "Reputation", "WebOS", "Shoes", "Nutrition", "Diabetes", "Art", "App Marketing", "Printing", "SNS", "Web Hosting", "Spam Filtering", "Fantasy Sports", "Recruiting", "VoIP", "Classifieds", "Cloud Infrastructure", "Penetration Testing", "Teenagers", "Android", "First Aid", "Content", "Online Auctions", "Cosmetics", "Skill Assessment", "Mobile Payments", "Corrections Facilities", "Task Management", "Employment", "Gift Card", "File Sharing", "Serious Games", "Social Media Marketing", "Speech Recognition", "Fruit", "Shipping", "Drones", "Water", "Diving", "Bitcoin", "Fertility", "Energy Storage", "Intelligent Systems", "Comics", "Facial Recognition", "Real Time", "Elder Care", "Wearables", "FinTech", "Health Diagnostics", "EdTech", "Delivery", "GreenTech", "Ride Sharing", "Podcast", "Cryptocurrency", "Subscription Service", "Graphic Design", "Furniture", "Social Entrepreneurship", "Industrial Design", "Hockey", "Google", "Twitter", "Software Engineering", "Drone Management", "Environmental Engineering", "Life Insurance", "Trading Platform", "Virtual Reality", "Roku", "Water Transportation", "Table Tennis", "Nuclear", "Quality Assurance", "Tizen", "Livestock", "Food Delivery", "Railroad", "Network Hardware", "Gift", "UX Design", "Commercial Insurance", "Auto Insurance", "Event Promotion", "Chemical Engineering", "Embedded Systems", "Millennials", "Mechanical Engineering", "Intrusion Detection", "Baseball", "Media and Entertainment", "IT Infrastructure", "Domain Registrar", "Management Information Systems", "Playstation", "Ultimate Frisbee", "Rugby", "Consumer Applications", "MOOC", "Fossil Fuels", "Windows", "Tennis", "Private Cloud", "DSP", "AgTech", "Product Research", "A/B Testing", "Commercial Lending", "Cycling", "Property Insurance", "Consumer Software", "Xbox", "Generation Z", "Nintendo", "Sharing Economy", "Adult", "Same Day Delivery", "Data Storage", "Vocational Education", "Satellite Communication", "GPU", "Cricket", "Air Transportation", "E-Signature", "Embedded Software", "Debit Cards", "Mobile Apps", "American Football", "Basketball", "Fast-Moving Consumer Goods", "Volley Ball", "Web Apps", "Lending", "Product Management", "Application Specific Integrated Circuit (ASIC)", "Ferry Service", "Car Sharing", "RISC", "Enterprise", "Micro Lending", "Cloud Storage", "Industrial Engineering", "Content Marketing", "B2C", "Ad Server", "Animation", "Ad Retargeting", "Ad Network", "Facility Management", "eSports", "Home Services", "Made to Order", "Home Improvement", "Leasing", "Virtual Assistant", "Electric Vehicle", "Compliance", "Computer", "Online Forums", "Optical Communication", "Fuel Cell", "TV", "Social", "Marketplace", "Rental", "Timeshare", "Vacation Rental", "Reservations", "E-Learning", "Affiliate Marketing", "Wellness", "Developer Platform", "Property Development", "STEM Education", "CMS", "Primary Education", "Health Insurance", "Dating", "Residential", "Enterprise Applications", "Boating", "Grocery", "Biomass Energy", "Franchise", "Communication Hardware", "Sex Tech", "Debt Collections", "Creative Agency", "Medical Device", "Home and Garden", "Laser", "GPS", "Life Science", "Assistive Technology", "Unified Communications", "Surfing", "Employee Benefits", "Biofuel", "Civil Engineering", "Music Label", "Online Portals", "macOS", "Emergency Medicine", "Social Shopping", "Technical Support", "Golf", "Wind Energy", "Building Material", "Semiconductor", "Music Streaming", "Textbook", "Government", "Hunting", "Social Network", "Family", "Limousine Service", "Data Center", "Freelance", "LGBT", "Courier Service", "Hospital", "Console Games", "Application Performance Management", "Electronic Design Automation (EDA)", "Real Estate Investment", "Marketing", "Local Shopping", "Windows Phone", "ISP", "Consumer Research", "Ad Exchange", "Consumer Reviews", "Usability Testing", "Asset Management", "Mapping Services", "Virtual Workforce", "Wedding", "Sensor", "Productivity Tools", "Scheduling", "Children", "Enterprise Resource Planning (ERP)", "CleanTech", "Baby", "Translation Service", "Pharmaceutical", "Continuing Education", "Cannabis", "Personal Development", "Sailing", "Mechanical Design", "Database", "Angel Investment", "PC Games", "Archiving Service", "Business Travel", "Shipping Broker", "Mining Technology", "Women's", "Consumer", "Men's", "Food and Beverage", "Field Support", "Rental Property", "Facebook", "Skiing", "Higher Education", "Virtual World", "Chemical", "Renewable Energy", "Video Advertising", "Gaming", "Funerals", "Mineral", "Local Business", "Hotel", "Electronic Health Record (EHR)", "Peer to Peer", "Fuel", "Biopharma", "Taxi Service", "Battery", "DRM", "Pollution Control", "Internet Radio", "Call Center", "Precious Metals", "Gift Registry", "Digital Marketing", "Sales", "SEM", "Generation Y", "Commercial", "Staffing Agency", "Secondary Education", "Pet", "Service Industry", "Flash Sale", "Online Games", "Building Maintenance", "Extermination Service", "Facilities Support Services", "Document Preparation", "Collection Agency", "Housekeeping Service", "Forestry", "Office Administration", "Horticulture", "Equestrian", "Trade Shows", "Credit Bureau", "Home Health Care", "Packaging Services", "Bakery", "Shopping Mall", "Industrial Manufacturing", "Winery", "Foundries", "Machinery Manufacturing", "Laundry and Dry-cleaning", "Hydroponics", "Confectionery", "Paper Manufacturing", "Timber", "Amusement Park and Arcade", "Ports and Harbors", "Tour Operator", "Social Assistance", "Casino", "Recipes", "Recreational Vehicles", "Travel Agency", "Seafood", "Wired Telecommunications", "Catering", "Outpatient Care", "Museums and Historical Sites", "Snack Food", "Distillery", "Contests", "Food Trucks", "Nursing and Residential Care", "Plastics and Rubber Manufacturing", "Freight Service", "Autonomous Vehicles", "Travel Accommodations", "Management Consulting", "Environmental Consulting", "Wood Processing", "Warehousing", "Janitorial Service", "Parks", "Delivery Service", "Marine Transportation", "Consumer Goods", "Mining", "Presentation Software", "GovTech", "Desktop Apps", "CivicTech", "Military", "Association", "InsurTech", "Funding Platform", "Blockchain", "Ethereum", "Quantum Computing", "Marine Technology", "Smart Cities", "Last Mile Transportation", "Legal Tech"]
}

function subsetBackground(index) {
  if (index >= 0 && index <= 10) {
    return [vals.LEGEND.BACKGROUND_COLORS_SUBSET_1, vals.LEGEND.BACKGROUND_COLORS_SUBSET_2, vals.LEGEND.BACKGROUND_COLORS_SUBSET_3, vals.LEGEND.BACKGROUND_COLORS_SUBSET_4, vals.LEGEND.BACKGROUND_COLORS_SUBSET_5,
    vals.LEGEND.BACKGROUND_COLORS_SUBSET_6, vals.LEGEND.BACKGROUND_COLORS_SUBSET_7, vals.LEGEND.BACKGROUND_COLORS_SUBSET_8, vals.LEGEND.BACKGROUND_COLORS_SUBSET_9, vals.LEGEND.BACKGROUND_COLORS_SUBSET_10][index]
  }
  return vals.LEGEND.BACKGROUND_COLORS_2 // default
}

function formatCurrency(value, format, minFraction, abbreviate = false) {
  if (_.isNil(minFraction)) minFraction = 0
  function formatString(toFormat) {
    return (new Intl.NumberFormat('en-US', { style: 'currency', currency: format, minimumFractionDigits: minFraction })).format(toFormat)
  }

  if (_.isUndefined(value) || _.isNull(value)) return formatString(0)
  else if (_.isNaN(parseFloat(value))) return formatString(0)
  else if (abbreviate) {
    // need the suffix from abbreviateNumber and the currency info from formatString
    let vals = abbreviateNumber(parseFloat(value))
    // 0 - new number, 1 - suffix
    if (vals[0] < 10 && minFraction < 1) minFraction = 1
    let retval = formatString(vals[0])
    return retval + vals[1]
    // return formatString(abbreviateNumber(parseFloat(value)))
  } else {
    return formatString(parseFloat(value))
  }

}

/**
 * https://stackoverflow.com/questions/10599933/convert-long-number-into-abbreviated-string-in-javascript-with-a-special-shortn
 * @param {*} value 
 */
function abbreviateNumber(value) {
  const suffixes = ["", "K", "M", "B", "T"];
  let shortValue = ''
    , suffixNum = '';
  if (value >= 10000) {
    suffixNum = Math.floor(("" + value).length / 3);
    if (value.toString().length % 3 === 0) suffixNum--; // want 300k not 0.3m
    // for (var precision = 2; precision >= 1; precision--) {
    //   shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
    //   var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
    //   if (dotLessShortValue.length <= 2) { break; }
    // }
    shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
    var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    return [shortValue, suffixes[suffixNum]];
  } else {
    return [value, '']
  }
}

function hasNumbers(t) {
  var regex = /\d/g;
  return regex.test(t);
}

function formatPortfolioImport(data) {
  return _.forIn(data, (v, k, o) => {
    let osflag = false
    if (typeof k === 'string') {
      delete o[k]
      k = k.toLowerCase()
        .replace(/[%$,\/\.\*\(\)@#]/g, ' ')
        .trim()
        .replace(/\s{1,}/g, '_')
        .replace('company', 'name')
        .replace('current_stage', 'stage')
        .replace('direct_lp', 'direct')
      if (vals.NUMBER_HEADERS.indexOf(k) >= 0) {
        osflag = k === 'ownership' && v.indexOf('%') < 0
        // parse as a number
        v = v.replace(/[$,%]/g, '')
        v = parseFloat(v) || 0
        v = (osflag) ? v * 100 : v
      } else if (vals.DATE_HEADERS.indexOf(k) >= 0) {
        v = moment.utc(v)
      }
      // set our formatted data
      o[k] = v
    }
    return true
  })
}


function formatNumber(labelValue) {

  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e+9

    ? Math.round(Math.abs(Number(labelValue)) / 1.0e+9) + "B"
    // Six Zeroes for Millions 
    : Math.abs(Number(labelValue)) >= 1.0e+6

      ? Math.round(Math.abs(Number(labelValue)) / 1.0e+6) + "M"
      // Three Zeroes for Thousands
      : Math.abs(Number(labelValue)) >= 1.0e+3

        ? Math.round(Math.abs(Number(labelValue)) / 1.0e+3) + "K"

        : Math.abs(Number(labelValue));
}

function humanFileSize(bytes, si) {
  var thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  var units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + '' + units[u];
}

function pickBackgroundColor(name) {
  let colors = [{ 'key': 'A', 'color': '#FFD490' }, { 'key': 'B', 'color': '#FFD490' },
  { 'key': 'C', 'color': '#FFD490' }, { 'key': 'D', 'color': '#FFD490' }, { 'key': 'E', 'color': '#FFD490' },
  { 'key': 'F', 'color': '#C1F2B2' }, { 'key': 'G', 'color': '#C1F2B2' }, { 'key': 'H', 'color': '#C1F2B2' },
  { 'key': 'I', 'color': '#C1F2B2' }, { 'key': 'J', 'color': '#C1F2B2' }, { 'key': 'K', 'color': '#B4DCFF' },
  { 'key': 'L', 'color': '#B4DCFF' }, { 'key': 'M', 'color': '#B4DCFF' }, { 'key': 'N', "color": '#B4DCFF' },
  { 'key': 'O', 'color': '#D5D5D5' }, { 'key': 'P', 'color': '#D5D5D5' }, { 'key': 'Q', 'color': "#FDD03B" },
  { 'key': 'R', 'color': '#D5D5D5' }, { 'key': 'S', 'color': '#D5D5D5' }, { 'key': 'T', 'color': '#FDD03B' },
  { 'key': 'U', 'color': '#FDD03B' }, { 'key': 'V', 'color': '#FDD03B' }, { 'key': 'W', "color": '#FF7676' },
  { 'key': 'X', 'color': '#FF7676' }, { 'key': 'Y', 'color': '#FF7676' }, { 'key': 'Z', 'color': '#FF7676' }]
  let char = name.charAt(0).toUpperCase();
  let colorObj = colors.find(item => item.key.toUpperCase() == char);
  if (colorObj) {
    return colorObj.color
  } else return '#5445F399'
}

function formatNumberWithComma(number) {
  if (isNaN(number)) {
    return '0';
  }

  let givenNumber = Number(number);
  let nfObject = new Intl.NumberFormat('en-US');
  return nfObject.format(givenNumber);
}

function arrayGroupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function precisionNumberForamtter(num, digits) {
  var si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    // { value: 1e9, symbol: "G" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (
    (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
  );
}

function cbAdapter(response) {
  return {
    data: {
      items: response.data.encrypt.entities.map((item) => {
        return {
          uuid: item.identifier.uuid,
          properties: {
            permalink: item.identifier.permalink,
            name: item.identifier.value,
            profile_image_url: `https://res.cloudinary.com/crunchbase-production/image/upload/${item.identifier.image_id}`,
          },
        };
      }),
    },
  };
}

export { vals, formatPortfolioImport, formatCurrency, subsetBackground, formatNumber, humanFileSize, pickBackgroundColor, formatNumberWithComma, arrayGroupBy, precisionNumberForamtter, cbAdapter }